module.exports = __webpack_public_path__ + "img/carro.52694049.png";